import type { ComboBoxOption } from "@dealer-center/core-components";
import type { ModelLocale } from "@dealer-center/inventory-pages-gvm-interface";

export const valueFromComboBox = (
  options: ComboBoxOption[]
): string | undefined => {
  return options && options.length > 0 ? options[0].value : undefined;
};

export function comboBoxValue(
  value: string | number | undefined
): ComboBoxOption[] {
  return value ? [{ label: String(value), value: String(value) }] : [];
}

export function localeComboBoxValue(
  locales: ModelLocale[] | undefined,
  localeId: string | undefined
): ComboBoxOption[] {
  if (!locales || !localeId) {
    return [];
  }
  const selectedLocale = locales.find(locale => locale.locale === localeId);
  return selectedLocale
    ? [{ label: selectedLocale.display, value: selectedLocale.locale }]
    : [];
}

export function valuesToComboBoxOptions(
  values: number[] | string[] | undefined
): ComboBoxOption[] {
  if (!values) {
    return [];
  }
  return values.map(item => ({
    value: String(item),
    label: String(item)
  }));
}
